/** CSS landing chargés tôt (module load) et retirés au unmount pour ne pas impacter /signin. */
const LANDING_STYLES = [
  {
    href: 'https://cdn.jsdelivr.net/npm/remixicon@3.5.0/fonts/remixicon.css',
    key: 'remixicon',
  },
  {
    href: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css',
    key: 'bootstrap',
  },
  {
    href: '/styles/landing.css',
    key: 'landing-custom',
  },
];

export function ensureLandingStylesheets() {
  if (typeof document === 'undefined') return;
  for (const { href, key } of LANDING_STYLES) {
    if (document.querySelector(`link[data-landing-css="${key}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-landing-css', key);
    document.head.appendChild(link);
  }
}

export function removeLandingStylesheets() {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('link[data-landing-css]').forEach((el) => el.remove());
}

/** Préchargement dès l’évaluation du chunk landing (avant le 1er paint). */
ensureLandingStylesheets();
